
import "core-js/stable";
import "regenerator-runtime/runtime";
import { runApp } from 'ice';
import moment from 'moment';
import React from 'react';
import { Provider } from 'react-redux';

import LocaleProvider from '@/components/LocaleProvider';
import { getLocale } from '@/utils/locale';

import { store } from './redux/store';

const locale = getLocale() || {};

// 在moment建立中文化月份列表
moment.updateLocale('zh-tw', {
  ...locale,
  week: {
    dow: 1,
    doy: 1,
  },
});

if (!window.structuredClone) {
  window.structuredClone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
  };
}

const appConfig = {
  app: {
    rootId: 'ice-container',
    parseSearchParams: true,
    addProvider: ({ children }) => (
      // 使用redux Provider包住整個app，讓全域可以使用redux
      <Provider store={store}>
        <LocaleProvider locale={'zh-TW'}>{children}</LocaleProvider>
      </Provider>
    ),
  },
  // router: {
  //   type: 'browser',
  // },
};
runApp(appConfig);

  